import { render, staticRenderFns } from "./LoadingFrame.vue?vue&type=template&id=001c6ee2&"
import script from "./LoadingFrame.vue?vue&type=script&lang=js&"
export * from "./LoadingFrame.vue?vue&type=script&lang=js&"
import style0 from "./LoadingFrame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports